// extracted by mini-css-extract-plugin
export default {"createEditModalCont":"ViewUsers_createEditModalCont__aJjOY","detailsLists":"ViewUsers_detailsLists__V5LpS","listContainers":"ViewUsers_listContainers__HVy81"};